import { AuthError } from "firebase/auth";
import { CustomError } from "ts-custom-error";

export class FirebaseAuthError extends CustomError {
  public constructor(error: AuthError) {
    super(`[${error.code}] ${error.message}`);
    Object.defineProperty(this, "name", { value: "FirebaseAuthError" });
  }
}
